import type {Dayjs} from '@myparcel-frontend/utils';
import {dayjs} from '@myparcel-frontend/utils';
import {useI18n} from 'vue-i18n';

// TODO: FE-3414 - Centralize date formatting
export const localizedDateFormat = (
  date: string | number | Date | null | undefined | Dayjs,
  format?: string,
): string => {
  const {locale} = useI18n();

  return dayjs(date).locale(locale.value).format(format);
};
